export enum Theme {
    DEFAULT = 'default',
    DARK = 'dark',
}
